import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import CityAutocomplete from '../../../components/ui/CityAutocomplete';

// Composant: Port + Ville + inversion sens
const DestinationSelector = ({
  selectedPort,
  onPortChange,
  selectedCity,
  onCityChange,
  direction,
  onDirectionChange,
}) => {
  const ports = [
    { value: 'fromentine', label: 'Fromentine' },
    { value: 'saint-gilles', label: 'Saint-Gilles-Croix-de-Vie' },
    { value: 'barbatre', label: 'Barbâtre' }
  ];

  const toggleDirection = () => {
    onDirectionChange(direction === 'city-to-port' ? 'port-to-city' : 'city-to-port');
  };

  return (
    <div className="bg-card rounded-lg p-4 maritime-shadow-sm border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-4">Trajet</h3>
      <div className="space-y-4">
  <div className="flex flex-col sm:flex-row items-stretch gap-3">
          {direction === 'city-to-port' ? (
            <CityAutocomplete
              label="Ville"
              value={selectedCity}
              onChange={onCityChange}
              placeholder="Votre ville de départ"
              className="flex-1"
              required
            />
          ) : (
            <Select
              label="Port"
              value={selectedPort}
              onChange={onPortChange}
              options={ports}
              placeholder="Port de départ"
              className="flex-1"
              required
            />
          )}
          <div className="flex flex-row sm:flex-col justify-center sm:justify-end order-none sm:order-none">
            <button
              type="button"
              onClick={toggleDirection}
              aria-label="Inverser le sens du trajet"
              className="h-10 w-10 rounded-md border border-border flex items-center justify-center hover:bg-accent maritime-transition mx-auto"
            >
              <Icon name="ArrowLeftRight" size={18} />
            </button>
          </div>
          {direction === 'city-to-port' ? (
            <Select
              label="Port"
              value={selectedPort}
              onChange={onPortChange}
              options={ports}
              placeholder="Port d'arrivée"
              className="flex-1"
              required
            />
          ) : (
            <CityAutocomplete
              label="Ville"
              value={selectedCity}
              onChange={onCityChange}
              placeholder="Ville d'arrivée"
              className="flex-1"
              required
            />
          )}
        </div>
        {selectedPort && selectedCity?.nom && (
          <div className="p-3 bg-primary/5 border border-primary/20 rounded-md text-sm flex items-center gap-2">
            <Icon name="MapPin" size={14} color="var(--color-primary)" />
            {direction === 'city-to-port'
              ? <span>{selectedCity?.nom} → {ports.find(p => p.value === selectedPort)?.label}</span>
              : <span>{ports.find(p => p.value === selectedPort)?.label} → {selectedCity?.nom}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default DestinationSelector;